import { useMemo } from 'react'
import ClientSideTable from '@/components/Table/ClientSideTable'
import useAL from '@/features/al/useAL'
import useECCN from '@/features/eccn/useECCN'
import useSystemVariable from '@/features/systemVariables/useSystemVariable'
import { getQuotationDetailTableColumns } from '@/features/vendors/routes/VendorUploadQuotationPage/VendorUploadQuotationDetailSection/quotationTeamplateDetailColumns'
import useZZZ6 from '@/features/zzz6/useZZZ6'
import { showModal } from '@/stores/ui/modal/modalSlice'
import { MODAL_TYPES } from '@/utils/constants/modalTypes'
import modalCallbackRegistry from '@/utils/modalCallbackRegistry'
import { useDispatch } from 'react-redux'

const QuotationDetailTable = ({
  costBudgetType,
  data,
  disabled,
  handleUpdateQuotationTemplateDetails,
  handleRemoveQuotationTemplateRow = () => {},
}) => {
  const dispatch = useDispatch()

  const { useFetchAllSystemVariables, useSystemVariableOptions } = useSystemVariable()
  const { data: hsCodeOptions } = useSystemVariableOptions('hsCode', {
    status: 'active',
    labelKey: (row) => `${row.code}`,
  })

  const { useFetchALs } = useAL()
  const { useFetchECCNs } = useECCN()
  const { useFetchZZZ6s } = useZZZ6()

  const { data: alData } = useFetchALs({
    page: 1,
    pageSize: 100000,
    filters: { status: 'active' },
  })

  const { data: eccnData } = useFetchECCNs({
    page: 1,
    pageSize: 100000,
    filters: { status: 'active' },
  })

  const { data: zzz6Data } = useFetchZZZ6s({
    page: 1,
    pageSize: 100000,
    filters: { status: 'active' },
  })

  const alOptions = useMemo(() => {
    if (!alData?.data) return []
    return alData.data.map((al) => ({
      value: al.code,
      label: al.code,
      country: al.country,
      description: al.description,
    }))
  }, [alData])

  const eccnOptions = useMemo(() => {
    if (!eccnData?.data) return []
    return eccnData.data.map((eccn) => ({
      value: eccn.code,
      label: eccn.code,
      country: eccn.country,
      description: eccn.description,
    }))
  }, [eccnData])

  const categoryOptions = useMemo(() => {
    if (!zzz6Data?.data) return []

    const categories = new Set()

    zzz6Data.data.forEach((zzz6) => {
      const rawCategories = zzz6?.Category

      if (Array.isArray(rawCategories)) {
        rawCategories.forEach((category) => {
          if (typeof category === 'string' && category.trim() !== '') {
            categories.add(category.trim())
          }
        })
        return
      }

      if (typeof rawCategories === 'string' && rawCategories.trim() !== '') {
        categories.add(rawCategories.trim())
      }
    })

    return Array.from(categories)
      .sort((left, right) => left.localeCompare(right))
      .map((category) => ({ value: category, label: category }))
  }, [zzz6Data])

  const handleOpenECCNDetailModel = (ECCNDetail) => {
    dispatch(
      showModal({
        modalType: MODAL_TYPES.ECCN_DETAIL,
        modalProps: {
          ECCNDetail: ECCNDetail,
          canEdit: !disabled,
        },
      })
    )
  }
  const columnDef = getQuotationDetailTableColumns({
    costBudgetType,
    hsCodeOptions: hsCodeOptions ?? [],
    alOptions: alOptions,
    eccnOptions: eccnOptions,
    categoryOptions: categoryOptions,
    handleRemove: handleRemoveQuotationTemplateRow,
    isTemplate: false,
    handleOpenECCNDetailModel,
  })
  return (
    <ClientSideTable
      tableWidth="100%"
      columnDef={columnDef}
      data={data}
      disabled={disabled}
      canSelect
      updateData={handleUpdateQuotationTemplateDetails}
    />
  )
}

export default QuotationDetailTable
